import React from 'react';
import styles from './ToggleQueueCardsPrompt.module.scss';
import { Button } from 'components/Button';
import { useTranslation } from 'hooks/useTranslation';

type Props = {
  updateItems: (operationType: 'add' | 'remove') => void;
  isRemoveDisabled: boolean;
  setShowQueueControlPrompt: (value: boolean) => void;
};

export const ToggleQueueCardsPrompt: React.FunctionComponent<Props> = ({
  updateItems,
  isRemoveDisabled = false,
  setShowQueueControlPrompt,
}) => {
  const t = useTranslation();

  return (
    <div className={styles.toggleQueuePrompt}>
      <Button
        text={t('addToQueueButton')}
        onClick={() => {
          updateItems('add');
          setShowQueueControlPrompt(false);
        }}
        size={'xs'}
        variant={'primary'}
        padding={'default'}
      />
      <Button
        text={t('removeFromQueueButton')}
        onClick={() => {
          updateItems('remove');
          setShowQueueControlPrompt(false);
        }}
        size={'xs'}
        variant={'primary'}
        padding={'default'}
        disabled={isRemoveDisabled}
      />
    </div>
  );
};
